import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../../redux/actions/authAction";
import { useNavigate } from "react-router-dom";
import notify from "../useNotifaction";
import { validateEmail } from "../../Feature/EmailValidRegex";

const ForgetPasswordHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  const OnChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const isComplate = validateEmail(email).length === 0;

  const onSubmit = async () => {
    if (email === "") {
      notify("من فضلك ادخل الايميل", "error");
      return;
    }
    localStorage.setItem("user-email", email);
    setLoading(true);
    await dispatch(
      forgetPassword({
        email,
      })
    );
    setLoading(false);
  };

  const res = useSelector((state) => state.authReducer.forgetPassword);

  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data.status === "Success") {
          notify("تم ارسال الكود للايميل بنجاح", "success");
          setTimeout(() => {
            navigate("/user/verify-code");
          }, 1000);
        }
        if (res.data.status === "fail") {
          notify("هذا الحساب غير موجود لدينا", "error");
        }
      }
    }
  }, [loading, navigate, res]);

  return [OnChangeEmail, email, onSubmit, isComplate];
};

export default ForgetPasswordHook;
